import { Dialog } from '@mui/material';
import { type ConnectedProps, connect } from 'react-redux';
import { type RootState } from '@/store';
import { isModalOpen, modalType, modalData, closeModal } from '../state';
import { getModalContent } from './getModalContent';
import styles from './styles';

type Props = ConnectedProps<typeof connector>;

const Modal = ({ isModalOpen, modalType, modalData, closeModal }: Props) => {
  const ModalContent = getModalContent(modalType);

  const handleClose = () => {
    closeModal();
  };

  return (
    <Dialog
      open={isModalOpen}
      onClose={handleClose}
      closeAfterTransition={false}
      slotProps={{
        paper: {
          sx: styles.paper,
        },
      }}
      disableEnforceFocus
    >
      <ModalContent closeModal={handleClose} modalData={modalData} />
    </Dialog>
  );
};

const connector = connect(
  (state: RootState) => ({
    isModalOpen: isModalOpen(state),
    modalType: modalType(state),
    modalData: modalData(state),
  }),
  { closeModal },
);

export default connector(Modal);
